export default __webpack_public_path__ + "static/media/template_business-man__0009_18---Tony-Gouga.ff275c0c.png";